import { paymentsTranslations } from "@esenda/core-ui";

const { en, fr, de } = paymentsTranslations;

export const supportedLocales = {
    "en-GB": en,
    "fr-FR": fr,
    "de-DE": de,
};
